/**
 * Cross-subdomain cookie utilities for .elebyte.io authentication
 *
 * The Auth portal (auth.elebyte.io) stores tokens in cookies on the
 * .elebyte.io domain after login. These helpers read/write/clear those
 * cookies so the Support portal can detect the authenticated session.
 */

export const COOKIE_NAMES = {
  ACCESS_TOKEN: 'elebyte_access_token',
  REFRESH_TOKEN: 'elebyte_refresh_token',
};

/**
 * Read a cookie value by name from document.cookie
 */
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return decodeURIComponent(parts.pop().split(';').shift());
  }
  return null;
}

/**
 * Set a cookie on the .elebyte.io domain for cross-subdomain access
 */
export function setCookie(name, value, days = 7) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=.elebyte.io; secure; samesite=lax`;
}

/**
 * Delete a cookie by expiring it across domain variations
 */
export function deleteCookie(name) {
  const expiry = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
  // Clear on .elebyte.io (how Auth portal sets it)
  document.cookie = `${name}=; ${expiry}; path=/; domain=.elebyte.io`;
  // Clear on bare hostname as fallback
  document.cookie = `${name}=; ${expiry}; path=/`;
}
